import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const muiCache = createCache({
	"key": "mui",
	"prepend": true
});
const columns = [
 {
  name: "c_name",
  label: "Course Name",
  options: {
   filter: false,
   sort: true,
  }
 },
 {
  name: "c_code",
  label: "Course Code",
  options: {
   filter: false,
   sort: true,
   display:false,
  }
 },
  {
  name: "cr_hr",
  label: "Cr.Hr",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
   name: "lec",
   label: "Lecture ",
   options: {
     filter: true,
     sort: true,
    }
  },
  {
    name: "lab",
  label: "Lab ",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
  name: "tut",
  label: "Tutorial",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
   name: "program_type",
  label: "Program Type",
  options: {
   filter: true,
   sort: true,
  }
},
{
  name: "admission_type",
  label: "Admission Type",
  options: {
    filter: true,
    sort: true,
  }
},
{
  name: "payment_rate",
  label: "Payment Rate(per LEH)",
  options: {
    filter: true,
    sort: true,
  }
},
{
  name: "n_section",
  label: "Sections",
  options: {
 filter: false,
 sort: true,
}
},
{
name: "n_students",
label: "Students",
options: {
  filter: false,
  sort: true,
}
},
{
name: "batch",
label: "Batch Year",
options: {
  filter: true,
  sort: true,
}
},
]


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  // '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },

  '& .tss-v24t37-MUIDataTableHeadCell-fixedHeader':{
    padding:'5px',
  },
  '& .tss-1l6och6-MUIDataTableHeadCell-fixedHeader':{
    padding:'5px',
  },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px',
  //   marginLeft:'-25px',
  //   textTransform:'none'
  // },
  
  // '& .css-1v17xvx-MuiTableCell-root':{
  //   padding:'0px',
  //   marginLeft:'-25px',
  //   textTransform:'none'
  // },
  // '& .css-10ud224-MuiTableCell-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',

  // },

}))
export default function OfferingTable(props) {

  console.log(props.data)
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={props.title}
  data={props.data}
  columns={columns}
  options={props.option}
/></CacheProvider>
 )} 